import { Component, OnInit } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: "app-college-placement-list",
  templateUrl: "./college-placement-list.component.html",
  styleUrls: ["./college-placement-list.component.scss"],
})
export class CollegePlacementListComponent implements OnInit {
  public list = [];
  message = null;
  class = null;

  constructor(private router: Router, private http: HttpClient) {}

  public settings = {
    actions: {
      position: "right",
      add: false,
      edit: false,
      delete: localStorage.getItem("userRole") == "admin" ? true : false,
    },
    delete: {
      confirmDelete: true,
    },
    columns: {
      college: {
        title: "College",
        valuePrepareFunction: (cell, row) => {
          return row.collegeDetails ? row.collegeDetails.collegename : 'N/A';
        },
        filterFunction: (cell?: any, search?: string) => {
          if (search.length === 0) {
            return true;
          }
          const collegeName = cell.collegeDetails ? cell.collegeDetails.collegename.toLowerCase() : '';
          return collegeName.includes(search.toLowerCase());
        }
      },
      course: {
        title: "Course",
        valuePrepareFunction: (cell, row) => {
          return row.courseDetails ? row.courseDetails.name : 'N/A';
        },
        filterFunction: (cell?: any, search?: string) => {
          if (search.length === 0) {
            return true;
          }
          const courseName = cell.courseDetails ? cell.courseDetails.name.toLowerCase() : '';
          return courseName.includes(search.toLowerCase());
        }
      },
      lowsalary: {
        title: "Low Salary",
        valuePrepareFunction: (value) => {
          return value ? `₹${value.toLocaleString()}` : 'N/A';
        }
      },
      averagesalary: {
        title: "Average Salary",
        valuePrepareFunction: (value) => {
          return value ? `₹${value.toLocaleString()}` : 'N/A';
        }
      },
      highsalary: {
        title: "High Salary",
        valuePrepareFunction: (value) => {
          return value ? `₹${value.toLocaleString()}` : 'N/A';
        }
      },
      _id: {
        title: "Actions",
        type: "html",
        valuePrepareFunction: (cell, row) => {
          return `
            <a href="#/college-details/edit-college-placement/${row._id}" class="btn btn-sm btn-primary me-1">
              <i class="fa fa-pencil"></i> Edit
            </a>
            ${localStorage.getItem("userRole") == "admin" ? 
            `<button class="btn btn-sm btn-danger" data-delete data-id="${row._id}">
              <i class="fa fa-trash"></i> Delete
            </button>` : ''}
          `;
        },
        filter: false,
        sort: false,
      },
    },
    pager: {
      display: true,
      perPage: 10
    },
    attr: {
      class: 'table table-bordered'
    }
  };

  ngOnInit() {
    this.loadPlacementData();
  }

  loadPlacementData() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");
    
    if (role == "admin") {
      this.http
        .get<any>(`${environment.apiUrl}/collegeplacement/`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            if (data.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            this.list = data.results || data;
            console.log('Placement data loaded:', this.list);
          },
          (err: HttpErrorResponse) => {
            console.error("Error loading placement data:", err);
            this.message = "Failed to load placement data";
            this.class = "btn-danger rounded px-1 py-1";
          }
        );
    } else {
      this.http
        .get<any>(`${environment.apiUrl}/collegeplacement/${user}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            if (data.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            this.list = data.results || data.data || [];
          },
          (err: HttpErrorResponse) => {
            console.error("Error loading user placement data:", err);
            this.message = "Failed to load placement data";
            this.class = "btn-danger rounded px-1 py-1";
          }
        );
    }
  }

  onCustomAction(event) {
    if (event.action === 'edit') {
      this.router.navigate([`/college-details/edit-college-placement/${event.data._id}`]);
    } else if (event.action === 'delete') {
      this.deleteRecord(event);
    }
  }

  deleteRecord(event) {
    if (confirm("Are You Sure You Want To Delete This Record?")) {
      this.http
        .delete<any>(`${environment.apiUrl}/collegeplacement/${event.data._id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            if (data.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            if (data.status == "500") {
              this.message = data.message;
              this.class = "btn-primary rounded px-1 py-1";
            } else {
              this.message = "Successfully Deleted";
              this.class = "btn-success rounded px-1 py-1";
              this.loadPlacementData(); // Reload the data
            }
          },
          (err: HttpErrorResponse) => {
            console.error("Error deleting record:", err);
            this.message = "Error deleting record";
            this.class = "btn-danger rounded px-1 py-1";
          }
        );
    }
  }
}